import React from 'react';

export const PaperPlane = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fillRule="evenodd" />
	</svg>
);
